<template>
  <div>
    DecisionViewsdafsdf
  </div>
</template>

<script>

export default {
  name: 'DecisionView',

  components: {
  },

  data() {
    return {
    }
  },

  methods: {
  }
};
</script>
